if (!customElements.get('cavador-wall-studio-comparison')) {
  customElements.define('cavador-wall-studio-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      const before = this.querySelector('[data-cv-label-before]');
      const after = this.querySelector('[data-cv-label-after]');
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let requested = this.motionRequested ?? (this.dataset.autoplay !== 'false' && !media.matches);
      let visible = false;
      let frame = 0;
      let started = null;
      let origin = 50;
      let phase = 0;

      const draw = (value) => {
        value = Math.max(0, Math.min(100, value));
        range.value = String(value);
        this.style.setProperty('--reveal', `${value}%`);
        range.setAttribute('aria-valuetext', (this.dataset.valueTemplate || '[percent]%').replace('[percent]', String(Math.round(value))));
        if (before) before.style.visibility = value < 18 ? 'hidden' : 'visible';
        if (after) after.style.visibility = value > 82 ? 'hidden' : 'visible';
      };
      const stopFrame = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        started = null;
      };
      const tick = (time) => {
        if (started === null) {
          started = time;
          origin = Number(range.value);
          phase = Math.asin(Math.max(-1, Math.min(1, (origin - 50) / 25)));
        }
        const elapsed = time - started;
        const settle = origin < 25 || origin > 75 ? 700 : 0;
        if (elapsed < settle) {
          const progress = elapsed / settle;
          const eased = progress * progress * (3 - 2 * progress);
          draw(origin + (Math.max(25, Math.min(75, origin)) - origin) * eased);
        } else {
          draw(50 + 25 * Math.sin(phase + (elapsed - settle) * Math.PI * 2 / 7000));
        }
        frame = requestAnimationFrame(tick);
      };
      const refresh = () => {
        if (controller.signal.aborted) return;
        this.motionRequested = requested;
        if (requested && !media.matches && visible && !document.hidden) {
          if (!frame) frame = requestAnimationFrame(tick);
        } else {
          stopFrame();
        }
      };
      const pause = () => {
        requested = false;
        refresh();
      };
      range.addEventListener('pointerdown', pause, options);
      range.addEventListener('keydown', pause, options);
      range.addEventListener('focus', pause, options);
      range.addEventListener('input', () => {
        pause();
        draw(Number(range.value));
      }, options);
      document.addEventListener('visibilitychange', refresh, options);
      media.addEventListener('change', () => {
        if (media.matches) requested = false;
        refresh();
      }, options);
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting && entry.intersectionRatio >= .25;
        refresh();
      }, { threshold: [0, .25] });
      observer.observe(this);
      this.cleanup = () => {
        controller.abort();
        observer.disconnect();
        stopFrame();
      };
      draw(Number.isFinite(Number(range.value)) ? Number(range.value) : 50);
      refresh();
    }

    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}